
import { useUUID } from "@/hooks/useUUID";
import { RegexResult } from "@/services/regexWatcherService";
import { getPathname } from "@/utils";
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
	props: {
		result: {
			type: Object as () => RegexResult,
			required: true,
		},
	},
	setup(props) {
		const { result } = toRefs(props);

		const sitemapPathname = computed(() =>
			getPathname(result.value.sitemap)
		);

		const uuid = useUUID();
		const matchesElementId = `matches-collapse-${uuid.value}`;

		return {
			sitemapPathname,
			matchesElementId,
		};
	},
});
